// extracted by mini-css-extract-plugin
export default {"title":"PageTitle_title__Nn+um","sub_page":"PageTitle_sub_page__R6jjb"};